<template>
  <section>
    <v-container>
      <h1 class="header-title optus-highlight optus-highlight--yellow">
        Question Overview&nbsp;
      </h1>
      <report-overview />
      <v-card class="filter-report pa-3 mb-3 mt-3">
        <v-card-title>
          <h2>Question Report&nbsp;</h2>
        </v-card-title>
        <v-row row wrap class="mb-3">
          <v-col sm="4" cols="12" class="px-0 pt-6">
            <v-select
              :items="lessonNames"
              v-model="selectedLesson"
              :label="`Choose ${this.lessonTerm}`"
              return-object
              dense
              class="pl-3 mr-5"
            >
              <template v-slot:selection="{ item }">
                <v-chip x-small>
                  <span>{{ item.text }}</span>
                </v-chip>
              </template>
            </v-select>
          </v-col>
          <v-col sm="4" cols="12" class="px-0 pt-6">
            <v-select
              :items="lessonOrders"
              v-model="selectedOrders"
              label="Choose question slide"
              multiple
              dense
              class="pl-3 mr-5"
            >
              <template v-slot:selection="{ item }">
                <v-chip x-small>
                  <span>{{ item }}</span>
                </v-chip>
              </template>
            </v-select>
          </v-col>
          <v-col sm="4" cols="12" class="pa-0" style="margin-left: -3%;">
            <report-date-picker
              :prop-date-from="dateFrom"
              :prop-date-to="dateTo"
              :prop-date-min="dateMin"
              :prop-date-max="dateMax"
              @dateToSelected="dateToSelected"
              @dateFromSelected="dateFromSelected"
            />
          </v-col>
        </v-row>
        <impact-report-data-table
          @csvExport="csvExport"
          :headers="[]"
          :items="items"
          :loading="loading"
        />
      </v-card>
    </v-container>
  </section>
</template>

<script>
import Lesson from '@/modules/lesson/models/Lesson'
import ReportOverview from '../ReportOverview'
import ImpactReportDataTable from '../ImpactReportDataTable'
import ReportDatePicker from '../ReportDatePicker'
import ReportsMixin from '../reports-mixin'

import FileMixin from '../file-mixin'
import { mapState } from 'vuex'
import Config from '@/modules/config/models/Config'

export default {
  components: {
    ReportOverview,
    ImpactReportDataTable,
    ReportDatePicker
  },
  mixins: [ReportsMixin, FileMixin],
  async mounted() {
    this.loading = true
    this.type = 'survey' // type is a mixin attribute
    await Lesson.dispatch('fetch', this.$route.meta.type)

    /* 
      Changing selectedLesson will trigger selectedOrder watch method 
      that will then fire the mixin's search method
    */
    this.selectedLesson = this.lessonNames[0]

    this.setDataset()
    this.loading = false
  },
  data() {
    return {
      modal: false,
      loading: false,
      items: [],
      selectVersion: 'No',
      dateMin: null,
      dateMax: null,
      selectedLesson: null,
      selectedOrders: null
    }
  },
  watch: {
    selectedLesson(val) {
      let parsedobj = JSON.parse(JSON.stringify(val))
      let slug = parsedobj.value
      this.lessonSelected(slug)
      this.selectedOrders = this.lessonOrders
    },
    selectedOrders(val) {
      let parsedobj = JSON.parse(JSON.stringify(val))
      this.orderSelected(parsedobj)
    },
    selectVersion(val) {
      let datasetDate = Config.value('datasetDate')
      let currentDateFrom = this.$moment(this.dateFrom)
      let currentDateTo = this.$moment(this.dateTo)
      let currentdatasetDate = this.$moment(datasetDate)

      if (datasetDate) {
        if (val === 'No') {
          this.dateMin = datasetDate
          this.dateMax = null

          if (currentDateFrom < currentdatasetDate) this.dateFrom = datasetDate
          if (currentDateTo < currentdatasetDate)
            this.dateTo = this.$moment.today
        } else {
          this.dateMax = this.$moment(datasetDate)
            .subtract(1, 'days')
            .format('YYYY-MM-DD')
          this.dateMin = null

          if (currentDateFrom >= currentdatasetDate)
            this.dateFrom = this.$moment(datasetDate)
              .subtract(1, 'days')
              .format('YYYY-MM-DD')
          if (currentDateTo > currentdatasetDate) this.dateTo = this.dateMax
        }
      }
    }
  },
  computed: {
    ...mapState(['lessonTerm']),
    hasDataset() {
      return Config.value('datasetDate')
    },
    lessonNames() {
      return Lesson.all().map(val => ({ text: val.name, value: val.slug }))
    },
    lessonOrders() {
      let slug = this.selectedLesson ? this.selectedLesson.value : ''
      let activeLesson = Lesson.query()
        .where('slug', slug)
        .get()

      if (activeLesson.length < 1) return []
      let surveys = activeLesson[0].lesson_slides.filter(
        v => v.name === 'survey_quiz'
      )
      return surveys.map(val => val.order)
    },
    lessons() {
      return Lesson.all()
    },
    headers() {
      return [
        {
          text: `${this.capitalizeFirstLetter(this.lessonTerm)} Title`,
          value: 'lesson_title'
        },
        {
          text: 'No. of Schools Using',
          value: 'schools_count',
          align: 'center'
        },
        {
          text: 'No. of Teachers using',
          value: 'teachers_count',
          align: 'center'
        },
        {
          text: `No. of Classes with ${this.capitalizeFirstLetter(
            this.lessonTerm
          )} Assigned`,
          value: 'custom_class_count',
          align: 'center'
        },
        {
          text: 'No. Student Completion',
          value: 'student_completion',
          align: 'center'
        },
        {
          text: 'Avg. Pre Quiz Score',
          value: 'average_pre_quiz',
          align: 'center'
        },
        {
          text: 'Avg. Post Quiz Score',
          value: 'average_post_quiz',
          align: 'center'
        }
      ]
    },
    dataVersion() {
      return ['Yes', 'No']
    }
  },
  methods: {
    setDataset() {
      let datasetDate = Config.value('datasetDate')
      let currentDateFrom = this.$moment(this.dateFrom)
      let currentDateTo = this.$moment(this.dateTo)
      let currentdatasetDate = this.$moment(datasetDate)

      if (datasetDate) {
        if (this.selectVersion === 'No') {
          this.dateMin = datasetDate
          this.dateMax = null

          if (currentDateFrom < currentdatasetDate) this.dateFrom = datasetDate
          if (currentDateTo < currentdatasetDate) this.dateTo = datasetDate
        } else {
          this.dateMax = datasetDate
          this.dateMin = null

          if (currentDateFrom > currentdatasetDate) this.dateFrom = datasetDate
          if (currentDateTo > currentdatasetDate) this.dateTo = datasetDate
        }
      }
    }
  }
}
</script>

<style lang="scss">
.filter-report {
  width: 100%;

  h2 {
    display: block;
    width: 100%;
  }

  p {
    padding: 0;
    margin: 0;
  }
}
</style>
